const isMapPortalUrl = (): boolean => {
  const searchParams = new URLSearchParams(window.location.search);

  const mapPortalParamsAreDefined =
    searchParams.has('lat') && searchParams.has('lng');

  return mapPortalParamsAreDefined;
};

export default isMapPortalUrl;
